export default __webpack_public_path__ + "static/media/cardsResponsive_en.29c5e987.png";